export const studyCentre =
{
    path: "/studyCentre",
    component: () => import("@/views/studyCentre/index.vue"),
    meta: {
        hidden: false,
        name: 'studyCentre'
    },
}

export const seriesList =
{
    path: "/seriesList",
    component: () => import("@/views/studyCentre/seriesList.vue"),
    meta: {
        hidden: false,
        name: 'seriesList'
    },
}

export const seriesDetail =
{
    path: "/seriesDetail",
    component: () => import("@/views/studyCentre/seriesDetail.vue"),
    meta: {
        hidden: false,
        name: '系列课程详情'
    },
}

export const seriesCourses =
{
    path: "/seriesCourses",
    component: () => import("@/views/studyCentre/seriesCourses.vue"),
    meta: {
        hidden: false,
        name: '系列课程'
    },
}

export const classifyList =
{
    path: "/classifyList",
    component: () => import("@/views/studyCentre/classifyList.vue"),
    meta: {
        hidden: false,
        name: '系列课程'
    },
}

export const myStudy =
{
    path: "/myStudy",
    component: () => import("@/views/studyCentre/myStudy.vue"),
    meta: {
        hidden: false,
        name: '系列课程'
    },
}

export const myAnswer =
{
    path: "/myAnswer",
    component: () => import("@/views/studyCentre/myAnswer.vue"),
    meta: {
        hidden: false,
        name: '我的答题'
    },
}

export const studyForm =
{
    path: "/studyForm",
    component: () => import("@/views/studyCentre/studyForm.vue"),
    meta: {
        hidden: false,
        name: '学习报表'
    },
}